import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getOrder } from '../../selectors/order/get-order';
import { assertIsOrderCreated } from '../../utils/order-type-utils';
export const loadOrderCustomer = async () => {
    const order = getOrder();
    assertIsOrderCreated(order, 'Cannot load customer');
    if (!order.hasCustomer)
        return undefined;
    return ocapiClient.instance.v1.orders.customer.get(order.id);
};
